<template>
  <VcConfirmModal :show-dialog="show"
                  :title="texts.title"
                  :content-text="texts.content"
                  :use-offset="false"
                  :wrap-title="true"
                  size="sm"
                  @onCloseButtonClicked="$emit('close')">
    <template #footer>
      <VcModalFooter :buttons="buttons"
                     @onOkClicked="$emit('delete')"
                     @onCancelClicked="$emit('close')"/>
    </template>
  </VcConfirmModal>
</template>

<script>
export default {
  name: "DocuformDeleteConfirmation",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    texts() {
      return {
        title: this.$t(`document.delete_confirmation.${this.type}.title`),
        content: this.$t(`document.delete_confirmation.${this.type}.description`),
        button: this.$t(`document.delete_confirmation.${this.type}.ok_button`)
      }
    },
    buttons() {
      return [
        {label: this.$t('common.dialog.cancel'), event: 'onCancelClicked', color: 'white'},
        {label: this.texts.button, event: 'onOkClicked', color: 'secondary'}
      ];
    }
  }
}
</script>
